import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  isAuthRedirectError,
  redirectToLoginFromAuthFailure,
} from "features/Authentication/authRecovery";
import { useEffect, useState } from "react";
import AuthService from "../services/AuthService";

export function useInitializeAuth(): {
  loading: boolean;
  initialized: boolean;
} {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance, inProgress } = useMsal();
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (
      isAuthenticated &&
      accounts.length > 0 &&
      !initialized &&
      inProgress === InteractionStatus.None
    ) {
      // Populate Apollo cache with backend user data
      AuthService.authCheck()
        .then((response) => {
          if (response.data.me?.userId) {
            localStorage.setItem("userID", response.data.me.userId.toString());
            setInitialized(true);
          } else {
            redirectToLoginFromAuthFailure({ instance });
          }
        })
        .catch((error) => {
          if (isAuthRedirectError(error)) {
            return;
          }
          try {
            redirectToLoginFromAuthFailure({ instance });
          } catch (e) {
            if (!isAuthRedirectError(e)) throw e;
          }
        })
        .finally(() => setLoading(false));
    } else if (!isAuthenticated) {
      setInitialized(false);
      setLoading(false);
    }
  }, [isAuthenticated, accounts, initialized, instance, inProgress]);

  return { loading, initialized };
}
